import { render, staticRenderFns } from "./ordersInTransitList.vue?vue&type=template&id=a179075a&scoped=true"
import script from "./ordersInTransitList.vue?vue&type=script&lang=js"
export * from "./ordersInTransitList.vue?vue&type=script&lang=js"
import style0 from "./ordersInTransitList.vue?vue&type=style&index=0&id=a179075a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a179075a",
  null
  
)

export default component.exports